<template>
  <div class="min-h-screen bg-canvas flex items-center justify-center py-10 px-5">
    <div class="w-full max-w-[420px]">
      <loader v-if="isLoading"></loader>
      <div v-else class="bg-white border border-border rounded-[20px] px-9 pt-10 pb-8">
        <div class="text-center mb-8">
          <img src="/static/images/unicorn.png" alt="Unicorn Visa" width="48" class="rounded-full mb-5 mx-auto block">
          <h1 class="text-[22px] font-bold text-ink tracking-[-0.02em] m-0 mb-1.5">Reset password</h1>
          <p class="text-sm text-muted m-0">Enter your email and we'll send a reset link</p>
        </div>

        <form class="flex flex-col gap-4" @submit.prevent="onSubmit">
          <div>
            <label class="text-[13px] font-semibold text-ink mb-1.5 block" for="resetEmail">Email</label>
            <input
              id="resetEmail"
              class="w-full h-11 border border-border-hover rounded-xl text-sm text-ink px-3.5 transition-[border-color,box-shadow] duration-150 bg-[#fafafa] box-border focus:border-primary focus:shadow-[0_0_0_3px_rgba(124,91,234,0.1)] focus:bg-white placeholder:text-placeholder"
              required
              type="email"
              name="email"
              v-model="email"
              placeholder="you@company.com">
          </div>

          <div v-if="submitted" class="flex items-center gap-2.5 bg-[#e2f3d1] border border-[#c5e4ad] rounded-xl py-3 px-3.5 mb-4 text-[#2d7a0e]">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            <p class="m-0 text-[13px] font-medium">Check your inbox for the reset link.</p>
          </div>

          <div v-if="error" class="bg-[#fef2f2] border border-[#fecaca] rounded-xl py-2.5 px-3.5 mb-4">
            <p v-if="error.code === 'auth/wrong-password'" class="m-0 text-[13px] text-[#e53935] font-medium">Wrong password</p>
            <p v-else class="m-0 text-[13px] text-[#e53935] font-medium">{{ error.message }}</p>
          </div>

          <vue-recaptcha
            ref="invisibleRecaptcha"
            sitekey="6Lde0-YUAAAAAFrFCIUommtp49SMEDtmmFK5sM1u"
            @verify="onVerify"
            @expired="onExpired"
            v-if="!isLoading"
          >
            <button type="submit" class="w-full h-11 border-0 rounded-full text-sm font-semibold cursor-pointer transition-[opacity,box-shadow] duration-150 flex items-center justify-center gap-2 bg-ink text-white hover:bg-[#2a2b2d] hover:shadow-[0_2px_8px_rgba(0,0,0,0.1)] disabled:opacity-60 disabled:cursor-not-allowed" :disabled="isFormLoading">
              Send reset link
            </button>
          </vue-recaptcha>
        </form>

        <div class="text-center mt-6 pt-5 border-t border-border">
          <p class="m-0 text-sm text-muted">Remember your password? <router-link :to="{ name: 'login' }" class="text-primary font-semibold no-underline hover:opacity-80 hover:no-underline">Sign in</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import firebase from '@/firebase'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'reset',
  components: { VueRecaptcha },
  data () {
    return {
      isLoading: null,
      email: '',
      submitted: null
    }
  },
  computed: {
    ...mapState({
      isFormLoading: state => state.auth.loading
    }),
    user () {
      return this.$store.getters.getUser
    },
    error () {
      return this.$store.getters.getError
    }
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch('SET_LOADING', true)
    setTimeout(() => {
      this.isLoading = false
      this.$store.dispatch('SET_LOADING', false)
    }, 1000)

    if (this.user !== null && this.user !== undefined) {
      this.$router.push({ name: 'components' })
    }
  },
  methods: {
    reset () {
      const user = {
        email: this.email
      }
      this.$store.dispatch('RESET_PASSWORD', user).then(() => {
        this.submitted = true
      })
    },
    onSubmit () {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify (response) {
      this.isLoading = true
      this.EventHolder.$emit('startLoading')
      if (response) {
        this.isLoading = false
        this.EventHolder.$emit('stopLoading')
        if (this.email) {
          this.reset()
        }
      }
      this.$refs.invisibleRecaptcha.reset()
    },
    onExpired () {
      console.log('Expired')
    },
    resetRecaptcha () {
      this.$refs.recaptcha.reset()
    }
  },
  created () {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('AUTO_SIGN_IN', user)
      }
    })
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push({ name: 'admin-applicants' })
      }
    }
  }
}
</script>
